import React, { useState } from 'react';
import { FiDownload } from 'react-icons/fi';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './ExportPDFButton.css';

const ExportPDFButton = ({
  targetId = 'pdf-content',
  fileName = 'export-ogp-immo',
  title = 'OGP IMMO',
  orientation = 'portrait',
  buttonText = 'Exporter en PDF',
  className = '',
}) => {
  const [exporting, setExporting] = useState(false);

  const exportToPDF = async () => {
    const element = document.getElementById(targetId);
    if (!element) {
      console.error('Element #' + targetId + ' introuvable');
      return;
    }
    setExporting(true);
    try {
      const exportButtons = document.querySelectorAll('.export-pdf-btn');
      const sidebar = document.querySelector('.sidebar');
      const header = document.querySelector('.header');
      exportButtons.forEach(btn => (btn.style.display = 'none'));
      if (sidebar) sidebar.style.display = 'none';
      if (header) header.style.display = 'none';
      await new Promise(resolve => setTimeout(resolve, 200));
      const canvas = await html2canvas(element, {
        scale: 2, useCORS: true, allowTaint: true,
        backgroundColor: '#F5F7FA', logging: false,
        ignoreElements: (el) => el.classList && el.classList.contains('no-pdf'),
      });
      exportButtons.forEach(btn => (btn.style.display = ''));
      if (sidebar) sidebar.style.display = '';
      if (header) header.style.display = '';
      const isLandscape = orientation === 'landscape';
      const pdf = new jsPDF({ orientation: isLandscape ? 'l' : 'p', unit: 'mm', format: 'a4' });
      const pdfWidth = isLandscape ? 297 : 210;
      const pdfHeight = isLandscape ? 210 : 297;
      const margin = 10;
      const headerH = 18;
      const footerH = 10;
      const contentWidth = pdfWidth - margin * 2;
      const contentHeight = pdfHeight - headerH - footerH - margin;
      const imgWidth = contentWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const totalPages = Math.ceil(imgHeight / contentHeight);
      for (var i = 0; i < totalPages; i++) {
        if (i > 0) pdf.addPage();
        pdf.setFillColor(10, 22, 40);
        pdf.rect(0, 0, pdfWidth, 14, 'F');
        pdf.setFillColor(201, 168, 76);
        pdf.rect(0, 14, pdfWidth, 2, 'F');
        pdf.setTextColor(255, 255, 255);
        pdf.setFontSize(11);
        pdf.setFont('helvetica', 'bold');
        pdf.text(title, margin, 9);
        pdf.setFontSize(8);
        pdf.setFont('helvetica', 'normal');
        var dateStr = new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
        pdf.text(dateStr, pdfWidth - margin, 9, { align: 'right' });
        var srcY = i * contentHeight;
        var srcH = Math.min(contentHeight, imgHeight - srcY);
        var tmpCanvas = document.createElement('canvas');
        var ratio = canvas.width / imgWidth;
        tmpCanvas.width = canvas.width;
        tmpCanvas.height = srcH * ratio;
        var ctx = tmpCanvas.getContext('2d');
        ctx.drawImage(canvas, 0, srcY * ratio, tmpCanvas.width, tmpCanvas.height, 0, 0, tmpCanvas.width, tmpCanvas.height);
        var pageImgData = tmpCanvas.toDataURL('image/jpeg', 0.92);
        pdf.addImage(pageImgData, 'JPEG', margin, headerH, contentWidth, srcH, undefined, 'FAST');
        pdf.setFillColor(10, 22, 40);
        pdf.rect(0, pdfHeight - 8, pdfWidth, 8, 'F');
        pdf.setTextColor(232, 204, 122);
        pdf.setFontSize(7);
        pdf.text('OGP - Office Guineen de Publicite | Page ' + (i + 1) + '/' + totalPages, pdfWidth / 2, pdfHeight - 3, { align: 'center' });
      }
      pdf.save(fileName + '_' + new Date().toISOString().slice(0, 10) + '.pdf');
    } catch (error) {
      console.error('Erreur export PDF:', error);
      alert('Erreur lors de la generation du PDF.');
    } finally {
      setExporting(false);
    }
  };

  return (
    <button className={'export-pdf-btn ' + className} onClick={exportToPDF} disabled={exporting} title="Exporter cette page en PDF">
      {exporting ? (<><span className="export-pdf-spinner"></span>Export en cours...</>) : (<><FiDownload />{buttonText}</>)}
    </button>
  );
};
export default ExportPDFButton;
